import React from 'react';

import { Box } from '@rbilabs/universal-components';

import { IServerOrder } from '@rbi-ctg/menu';

import PayPalButton from './paypal-button';
import { IBraintreeResult } from './types';
import VenmoButton from './venmo-button';

const Spacer = Box.withConfig({
  marginTop: '$5',
});

interface IPayPalVenmoExtraDisplay {
  serverOrder: IServerOrder | null;
  onPayPalResult: (result: IBraintreeResult) => void;
  onPayPalError: (error: Error) => void;
  onVenmoResult: (result: IBraintreeResult) => void;
  onVenmoError: (error: Error) => void;
  isPayPalAvailable: boolean;
  isVenmoAvailable: boolean;
}

const PayPalVenmoExtraDisplay: React.FC<IPayPalVenmoExtraDisplay> = ({
  serverOrder,
  onPayPalResult,
  onPayPalError,
  onVenmoResult,
  onVenmoError,
  isPayPalAvailable,
  isVenmoAvailable,
}) => {
  const payPalContent = isPayPalAvailable ? (
    <>
      <Spacer />
      <PayPalButton
        serverOrder={serverOrder}
        onResult={onPayPalResult}
        onError={onPayPalError}
        showLoading={false}
      />
    </>
  ) : null;

  const venmoContent = isVenmoAvailable ? (
    <>
      <Spacer />
      <VenmoButton
        serverOrder={serverOrder}
        onResult={onVenmoResult}
        onError={onVenmoError}
        showLoading={false}
      />
    </>
  ) : null;

  return (
    <>
      {payPalContent}
      {venmoContent}
    </>
  );
};

export { PayPalVenmoExtraDisplay };
